import Logo from "@assets/header/footer-logo.svg?react";
import MLogo from "@assets/header/footer-logo-m.svg?react";
import Copyright from "@assets/icons/copyright.svg?react";
import Button from "@components/Button/Button";
import Link from "@components/Link";
import Nav from "@components/Navigater";
import Share from "@src/app/components/SocialMedia";
import type { ReactElement } from "react";

const navList = [
  {
    name: "关于我们",
    path: "/about-us?ref=footer-page",
  },
  {
    name: "广告刊登",
    path: "https://www.sph.com.sg/contact-us/?ctopic=advertising",
  },
  {
    name: "版权说明",
    path: "/copyright?ref=footer-page",
  },
];

export default function Footer(): ReactElement {
  return (
    <section className="w-full" data-testid="redants-footer">
      <div className="box-border bg-inverse px-[36px]">
        <div className="mx-auto flex max-w-[1200px] items-center justify-center max-lg:flex-col lg:justify-between">
          <div className="flex items-center max-lg:flex-col max-lg:items-center">
            <Link to="/">
              <Logo className="mr-[40px] hidden lg:block" />
              <MLogo className="box-content block px-[12px] py-[16px] lg:hidden" />
            </Link>
            <div className="max-lg:px-[12px] max-lg:py-[16px]">
              <Nav
                className="px-[8px] py-[5px] text-button-2 text-primary-on-dark lg:hover:!text-primary"
                navList={navList}
              />
            </div>
          </div>
          <div className="flex items-center justify-end max-lg:px-[12px] max-lg:py-[16px] lg:h-[104px]">
            <Share />

            <Button
              size="large"
              className="box-border flex h-[40px] w-[64px] items-center justify-center text-button-1 text-button-primary-label"
            >
              <Link className="whitespace-nowrap" to="/submission?ref=footer">
                投稿
              </Link>
            </Button>
          </div>
        </div>
      </div>
      <div className="lg:[16px] flex items-center justify-center bg-secondary px-[12px] py-[11px]">
        <p className="flex items-center gap-[2px] text-label text-secondary">
          <Copyright className="align-middle" /> Red Anthill Ventures Pte. Ltd.
          版权所有
        </p>
      </div>
    </section>
  );
}
